/**
 * Nexus — unified multi-organization & executive command center hub.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import { systemStatsKeys } from "../../../hooks/useSystemStats";
import { getSystemStats } from "../../../server/stats";
import NexusDashboard from "@/pages/Admin/Nexus";

export const Route = createFileRoute("/_admin/nexus/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData({
      queryKey: systemStatsKeys.stats(),
      queryFn: async () => {
        const result = await getSystemStats({ data: {} });
        if (result.error) throw new Error(`Failed to load system stats: ${result.error}`);
        return result.data;
      },
      staleTime: 1000 * 60 * 5,
    });
  },
  pendingComponent: () => <PageSkeleton rows={6} variant="cards" />,
  errorComponent: createRouteError("Nexus"),
  component: NexusRoute,
});

function NexusRoute() {
  return (
    <div className="flex min-h-0 flex-1 flex-col p-6">
      <NexusDashboard />
    </div>
  );
}
